import React, { Component } from 'react'
import intl from 'react-intl-universal'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import moment from 'moment'
import 'moment-timezone'
import shortid from 'shortid'
import prepare_rating from '../api/prepare_rating'
import ExperienceUser from './ExperienceUser'
import Reviews from './Reviews'
import WishlistButton from './WishlistButton'
import Map from './Map'
import object_value from '../api/object_value'

@inject('user', 'modals', 'experiences', 'userById')
@observer
class Experience extends Component {
  constructor (props) {
    super(props)
    console.log('Experience.js - constructor() - props', props)

    const { user, experience, userById } = props

    let image_url = experience.image_url
    let image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    // Load experience user
    // let token = user.token
    // if (token) {
      userById.get(experience.user_id)
    // }

    this.state = {
      showDatesModal: false,
      image_style
    }
  }

  // Update content on change
  componentWillUpdate (nextProps, nextState) {
    console.log('Experience.js - componentWillUpdate() - nextProps', nextProps)
    let old_login = this.props.user.login
    console.log('Experience.js - componentWillUpdate() - old_login', old_login)
    let next_login = nextProps.user.login
    console.log('Experience.js - componentWillUpdate() - next_login', next_login)
    if (old_login !== next_login) {
      console.log('Experience.js - componentWillUpdate() - old_login !== next_login')
      const { user, experience, userById } = nextProps
      let token = user.token
      if (token) {
        // Clean before next
        userById.clean()
        // Get next
        userById.get(experience.user_id, user.token)
      }
    }
  }

  // Clean on leave
  componentWillUnmount () {
    this.props.userById.clean()
  }

  openDatesModal = (event) => {
    event.preventDefault()
    this.setState({showDatesModal: true})
    document.body.classList.add('js-modal-opened')
  }

  closeDatesModal = (event) => {
    event.preventDefault()
    this.setState({showDatesModal: false})
    document.body.classList.remove('js-modal-opened')
  }

  handleOnclickSingInFirst = (event, path) => {
    const {user} = this.props

    console.log(' - event:', event)
    console.log(' - path:', path)

    if (user.login) {
      return
    }

    event.preventDefault()

    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()

    this.props.modals.setModal('LoginModal', path)
  }

  render () {
    const { user, experiences, experience, userById } = this.props
    const experience_store = experiences
    console.log('Experience.js - render() - user', user)
    console.log('Experience.js - render() - experience', experience)
    console.log('Experience.js - render() - userById', userById)

    // Fix: undefined `experience` on first run of `render()`
    if (!experience) {
      return (<div />)
    }

    let experience_reviews = object_value(experience, 'ratings', [])
    let experience_location = object_value(experience, 'location', '') + ', ' + object_value(experience, 'city.name', '')

    function experience_language () {
      let language
      switch (experience.language) {
        case 'en':
          language = 'English'
          break
        case 'de':
          language = 'German'
          break
        default:
          language = 'English'
          break
      }
      return language
    }

    function format_event_date (date) {
      return moment(date).utc()/*.tz('Europe/Berlin')*/.format('dd[.] D[.] MMMM, YYYY')
    }

    function format_event_time (date, duration) {
      let start = moment(date).utc()/*.tz('Europe/Berlin')*/.format('H:mm')
      let end = moment(date).utc()/*.tz('Europe/Berlin')*/.add(duration, 'm').format('H:mm')
      return start + ' — ' + end
    }

    function isSameOrBefore(date) {
      return moment(date).isSameOrBefore(moment())
    }

    return (
      <section className='b-event'>
        {(experience.activated === "undefined" || !experience.activated) &&
        <div className='b-event-message'>
          <div className='b-message b-message_warning'>
            {intl.getHTML('experiences.not_activated')}
          </div>
        </div>}

        <div className='b-event-inner'>
          <div className='b-event-card'>
            <div className='b-event-card-image'
                 style={this.state.image_style} />
            <div className='b-event-card-title'>
              {experience.title}
            </div>
            <div className='b-event-card-description'>
              {experience.description}
            </div>

            <div className='b-event-card-meta'>
              <div className='b-event-card-meta-a'>
                <div className='b-event-card-price'>
                  € {experience.price}
                  <small>{intl.get('experiences.per_person')}</small>
                </div>

                <div className='b-event-card-rating'>
                  <div className='b-event-card-rating-stars'
                       data-rating={prepare_rating(experience.rating_average)}>
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                  <span>{experience.rating_amount} {intl.get('experiences.reviews')}</span>
                </div>
              </div>

              <button className='b-button b-button_primary b-button_x'
                      type='button'
                      onClick={this.openDatesModal}>{intl.get('experiences.see_dates')}</button>
            </div>

            {/* TODO: Make a modal component */}
            {this.state.showDatesModal &&
            <div className='b-modal-wrap'>
              <div className='b-modal'>
                <div className='b-modal-header b-modal-header_border'>
                  {intl.get('experiences.available_dates')}

                  <button className='b-button-close'
                          onClick={this.closeDatesModal}
                  />
                </div>
                <div className='b-modal-content'>

                  {experience.events.map((event, index) =>
                    <div className='b-event-date'
                         key={shortid.generate()}>
                      <div className='b-event-date-name'>
                        {format_event_date(event.date)}
                      </div>
                      <div className='b-event-date-details'>
                        <span>{format_event_time(event.date, experience.duration)}</span>
                        <span>{experience.price} € {intl.get('experiences.per_person')}</span>
                      </div>
                      {isSameOrBefore(event.date)
                        ? <button className='b-button b-button_inverted'
                                  type='button'
                                  disabled>
                          {intl.get('experiences.choose_date')}
                        </button>
                        : <NavLink className='b-button b-button_inverted'
                                   to={'/experience/' + experience.id + '/book/' + event.id}
                                   onClick={(e) => this.handleOnclickSingInFirst(e, '/experience/' + experience.id + '/book/' + event.id)}>
                          {intl.get('experiences.choose_date')}
                        </NavLink>
                      }
                    </div>
                  )}

                </div>
              </div>
            </div>}

            <div className='b-event-card-footer'>
              <div className='b-icons not-working'>
                <a href='#' className='b-icon b-icon_fb' />
                <a href='#' className='b-icon b-icon_twitter' />
                <a href='#' className='b-icon b-icon_envelope' />
              </div>
              {!!user.login &&
              <div className='b-event-card-wishlist'>
                <span>{intl.get('Wishlist')}</span>

                <WishlistButton experience_id={experience.id.toString()}
                                get_class='b-event-card-wishlist-liked' />
              </div>}
            </div>
          </div>

          <div className='b-event-details'>
            <div className='b-event-details-title'>
              {experience.title}
            </div>
            <div className='b-event-details-description'>
              {experience.description}
            </div>

            {!!userById.loaded &&
            <ExperienceUser experience_user={userById.data}
                            variant='details' />}

            <div className='b-event-details-blocks'>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('Location')}</div>
                <div className='b-event-details-block-value'>
                  {experience_location}
                </div>
              </div>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('Duration')}</div>
                <div className='b-event-details-block-value'>{experience_store.formatted_duration} h</div>
              </div>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('Language')}</div>
                <div className='b-event-details-block-value'>{experience_language()}</div>
              </div>
              {/*
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('Guests')}</div>
                <div className='b-event-details-block-value'>{experience.number_guests}</div>
              </div>
              */}
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('Category')}</div>
                <div className='b-event-details-block-value'>{experience.category.description}</div>
              </div>
            </div>

            <div className='b-event-details-blocks'>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('experiences.comment_label')}</div>
                <div className='b-event-details-block-value'>
                  {experience.comment}
                </div>
              </div>
            </div>
            <div className='b-event-details-blocks'>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('experiences.location_label')}</div>
                <div className='b-event-details-block-value'>
                  <p>{experience_location}</p>
                </div>
              </div>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-map'>
                  {experience.latitude &&
                  experience.longitude &&
                  <Map center={{
                    lat: parseFloat(experience.latitude),
                    lng: parseFloat(experience.longitude)
                  }} />}
                </div>
              </div>
            </div>

            {!!userById.loaded &&
            <ExperienceUser experience_user={userById.data}
                            variant='full' />}

            <div className='b-event-details-blocks'>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('experiences.available_dates')}</div>
                <div className='b-event-details-block-value'>
                  <div className='b-event-dates'>
                    {experience.events.slice(0, 3).map((event, index) =>
                      <div className='b-event-date'
                           key={shortid.generate()}>
                        <div className='b-event-date-name'>
                          {format_event_date(event.date)}
                        </div>
                        <div className='b-event-date-details'>
                          <span>{format_event_time(event.date, experience.duration)}</span>
                          <span>{experience.price} € {intl.get('experiences.per_person')}</span>
                        </div>
                        {isSameOrBefore(event.date)
                          ? <button className='b-button'
                                    type='button'
                                    disabled>
                          {intl.get('experiences.choose_date')}
                            </button>
                          : <NavLink className='b-button'
                                     to={'/experience/' + experience.id + '/book/' + event.id}
                                     onClick={(e) => this.handleOnclickSingInFirst(e, '/experience/' + experience.id + '/book/' + event.id)}>
                          {intl.get('experiences.choose_date')}
                            </NavLink>
                        }
                      </div>
                    )}
                    <button className='b-link'
                            type='button'
                            onClick={this.openDatesModal}>{intl.get('experiences.see_all_available_dates')}</button>
                  </div>
                </div>
              </div>
            </div>
            {experience_reviews &&
            <div className='b-event-details-blocks'>
              <div className='b-event-details-block'>
                <div className='b-event-details-block-label'>{intl.get('experiences.latest_reviews')}</div>
                <div className='b-event-details-block-value'>
                  {experience_reviews.length > 0
                    ? <Reviews reviews={experience_reviews} />
                    : <span>{intl.get('experiences.no_reviews')}</span>
                  }
                </div>
              </div>
            </div>}
          </div>
        </div>
      </section>
    )
  }
}

Experience.propTypes = {
  user: MobxPropTypes.observableObject,
  experiences: MobxPropTypes.observableObject,
  experience: {
    latitude: PropTypes.number,
    longitude: PropTypes.number
  },
  userById: MobxPropTypes.observableObject,
  modals: MobxPropTypes.observableObject
}

export default Experience



// WEBPACK FOOTER //
// ./src/components/Experience.js